import 'whatwg-fetch'
import md5 from 'blueimp-md5'
import { SIGNON, SIGNOFF } from './constants'

class AuthUtil {
  static loggedIn = () => !!localStorage.user
  static loggedOut = () => delete localStorage.user
  static getUser = () => JSON.parse(localStorage.getItem('user')) || null
  static setUser = user => localStorage.setItem('user', JSON.stringify(user))
  static getBasicAuth = () => {
    const user = JSON.parse(localStorage.getItem('user')) || null
    return user ? 'Basic ' + btoa(user.user + ":" + user.password) : null
  }

  static login = (user, pass) => {
    const data = JSON.stringify({ user: user, pass: md5(pass) })
    return fetch(SIGNON, {
      method: "POST",
      body: data
    }).then(response => {
      if (response.ok) {
        return response.json()
      }
      return ({error: 'Unauthorized'})
    })
  }

  static logout = (user) => {
    delete localStorage.user

    const data = JSON.stringify({ user: user })
    return fetch(SIGNOFF, {
      method: "POST",
      body: data
    }).then(response => {
      if (response.ok) {
        return response.json()
      }
      return ({error: 'Network error'})
    })
  }
}

export default AuthUtil



// WEBPACK FOOTER //
// ./src/lib/auth.js